import {engineContext} from './context.js';

(function(global){
'use strict';
const VERSION='0.1.0-alpha';

function norm(x){
  x=x||{};
  return Object.freeze({
    id:x.id||null,
    claim:x.claim||null,
    publisher:x.publisher||null,
    origin:x.origin||null,
    verification:['VERIFIED','PARTIAL','UNVERIFIED'].includes(x.verification)?x.verification:'UNVERIFIED'
  });
}
function familyKey(x){
  const n=norm(x);
  return n.origin||n.publisher||n.id||'UNKNOWN';
}
function independentCount(items){
  const rows=Array.isArray(items)?items.map(norm):[];
  return new Set(rows.map(familyKey)).size;
}
function corroboration(items){
  const rows=Array.isArray(items)?items.map(norm):[];
  const verified=rows.filter(x=>x.verification==='VERIFIED');
  const independent=independentCount(verified);
  let state='WEAK';
  if(verified.length>=2&&independent>=2) state='INDEPENDENT_CORROBORATION';
  else if(verified.length>=2&&independent===1) state='REPEATED_SAME_ORIGIN';
  else if(verified.length===1) state='SINGLE_VERIFIED_SOURCE';
  return Object.freeze({
    state,
    verifiedCount:verified.length,
    independentVerifiedCount:independent,
    tradeSignal:false
  });
}
function selfTest(){
  const t=[],ok=(n,p)=>t.push({name:n,pass:!!p});
  const same=[
    {id:'1',publisher:'A',origin:'WireX',verification:'VERIFIED'},
    {id:'2',publisher:'B',origin:'WireX',verification:'VERIFIED'}
  ];
  const independent=[
    {id:'1',publisher:'A',origin:'Primary1',verification:'VERIFIED'},
    {id:'2',publisher:'B',origin:'Primary2',verification:'VERIFIED'}
  ];
  ok('same origin counts once',independentCount(same)===1);
  ok('different origins count independently',independentCount(independent)===2);
  ok('same origin is not independent corroboration',corroboration(same).state==='REPEATED_SAME_ORIGIN');
  ok('two independent verified sources corroborate',corroboration(independent).state==='INDEPENDENT_CORROBORATION');
  ok('single verified source stays single-source',corroboration([independent[0]]).state==='SINGLE_VERIFIED_SOURCE');
  ok('unverified sources do not inflate verified count',corroboration([{origin:'A',verification:'UNVERIFIED'}]).verifiedCount===0);
  ok('independent verified count is explicit',corroboration(independent).independentVerifiedCount===2);
  ok('corroboration remains non-trading',corroboration(independent).tradeSignal===false);
  ok('publisher is fallback family key',familyKey({publisher:'A'})==='A');
  ok('id is final family fallback',familyKey({id:'X'})==='X');
  return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}
const API={VERSION,norm,familyKey,independentCount,corroboration,selfTest};
try{API.selfTestResult=selfTest()}catch(e){API.bootstrapError=String(e&&e.stack||e)}
global.ZooInvestSourceIndependenceGuard=Object.freeze(API);
})(engineContext);
